import React from 'react';
import Box from '@material-ui/core/Box';
import useThemeQuery from '../../graphql/queries/toggle-theme';

const TableBodyCell = ({ children, width, position, noPadding, last }) => {
    const { data } = useThemeQuery();

    return (
        <Box
            display="flex" 
            alignItems="center" 
            justifyContent={position} 
            style={ last ? {}: {borderRight: data && data.theme ? '2px solid #00132C': '2px solid #F0F0F2' }} 
            alignSelf="stretch" 
            width={width}
        >
            <Box px={!noPadding ? 3: 0} py={noPadding ? 0.5 : 3} flexGrow={1}>
                { children }
            </Box>
        </Box>
    )
}

export default TableBodyCell;
